export type ObjectiveOption = { id: string; label: string; phrase: string };

const generic: ObjectiveOption[] = [
  { id: "questions", label: "Tirar dúvidas", phrase: "atender às dúvidas dos clientes" },
  { id: "needs", label: "Entender o que o cliente procura", phrase: "identificar suas necessidades" },
  { id: "handoff", label: "Encaminhar pedidos à equipe", phrase: "encaminhar à equipe os pedidos que exigem atendimento humano" }
];

export function objectiveOptions(businessArea: string): ObjectiveOption[] {
  const area = businessArea.toLocaleLowerCase("pt-BR");
  if (/barbear|salão|cabel/.test(area)) return [
    { id: "questions", label: "Tirar dúvidas sobre cortes e barba", phrase: "atender às dúvidas dos clientes sobre os serviços oferecidos" },
    { id: "needs", label: "Entender o serviço desejado", phrase: "identificar suas necessidades" },
    { id: "handoff", label: "Encaminhar pedidos à equipe", phrase: "encaminhar à equipe os pedidos que exigem atendimento humano" }
  ];
  if (/advoc|juríd/.test(area)) return [
    { id: "questions", label: "Entender a demanda inicial", phrase: "entender a demanda inicial apresentada pelo cliente" },
    { id: "needs", label: "Explicar áreas de atuação confirmadas", phrase: "explicar as áreas de atuação já confirmadas" },
    { id: "handoff", label: "Encaminhar ao profissional responsável", phrase: "encaminhar à equipe os casos que exigem atendimento humano" }
  ];
  if (/clínic|estétic|odonto|saúde/.test(area)) return [
    { id: "questions", label: "Explicar serviços confirmados", phrase: "explicar os serviços confirmados pela empresa" },
    { id: "needs", label: "Entender a necessidade inicial", phrase: "entender a necessidade inicial do cliente" },
    { id: "handoff", label: "Encaminhar à equipe", phrase: "encaminhar à equipe os pedidos que exigem atendimento humano" }
  ];
  return generic;
}

export function humanHandoffOptions(): ObjectiveOption[] {
  return [
    { id: "requested", label: "Quando o cliente pedir para falar com uma pessoa", phrase: "encaminhar para uma pessoa quando o cliente pedir atendimento humano" },
    { id: "unresolved", label: "Quando a IA não conseguir resolver uma solicitação", phrase: "encaminhar para uma pessoa quando não conseguir resolver uma solicitação" },
    { id: "delicate", label: "Quando houver reclamação ou situação delicada", phrase: "encaminhar para uma pessoa diante de reclamações ou situações delicadas" },
    { id: "approval", label: "Quando precisar de confirmação ou autorização humana", phrase: "pedir confirmação ou autorização humana quando necessário" },
    { id: "exceptional", label: "Quando ocorrer uma situação excepcional definida pela empresa", phrase: "seguir a orientação da empresa em situações excepcionais" }
  ];
}

export function composeObjectives(options: ObjectiveOption[], selectedIds: string[]): string {
  const phrases = options.filter(option => selectedIds.includes(option.id)).map(option => option.phrase);
  if (!phrases.length) return "";
  if (phrases.length === 1) return `${capitalize(phrases[0])}.`;
  if (phrases.length === 2) return `${capitalize(phrases[0])} e ${phrases[1]}.`;
  return `${capitalize(phrases.slice(0, -1).join(", "))} e ${phrases.at(-1)}.`;
}

export function selectedObjectiveIds(value: string, options: ObjectiveOption[]): string[] {
  const candidateIds = options.map(option => option.id);
  for (let mask = 1; mask < (1 << candidateIds.length); mask++) {
    const ids = candidateIds.filter((_, index) => Boolean(mask & (1 << index)));
    if (composeObjectives(options, ids) === value.trim()) return ids;
  }
  return [];
}

function capitalize(value: string): string { return value.charAt(0).toLocaleUpperCase("pt-BR") + value.slice(1); }
